import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancelled = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F0FDF4' }}>
            <div className="bg-white rounded-3xl shadow-sm border border-purple-200/50 max-w-md w-full p-8 text-center">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#FFF7ED' }}>
                    <XCircle className="h-10 w-10 text-orange-500" />
                </div>
                
                <span className="uppercase tracking-[0.2em] text-xs font-semibold text-orange-500 block mb-2" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                    Cancelled
                </span>
                <h1 className="text-2xl font-bold mb-2 tracking-tight" style={{ fontFamily: 'Unbounded, sans-serif', color: '#0A0A0A' }}>
                    Payment Cancelled
                </h1>
                <p className="text-slate-500 mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                    Your trial booking payment was not completed. Your booking is saved and you can retry payment at any time.
                </p>

                <div className="bg-amber-50 rounded-2xl p-4 mb-6 text-left text-sm text-amber-800 border border-amber-200/50">
                    <p className="font-semibold mb-1" style={{ fontFamily: 'Unbounded, sans-serif' }}>What happens next?</p>
                    <ul className="space-y-1 text-amber-700" style={{ fontFamily: 'Barlow, sans-serif' }}>
                        <li>Your booking remains in "Pending Payment" status</li>
                        <li>You can complete payment from the Trials page</li>
                        <li>No charges have been made to your card</li>
                    </ul>
                </div>

                <div className="space-y-3">
                    <Button
                        onClick={() => navigate(-1)}
                        className="w-full btn-primary h-12"
                        data-testid="try-again-btn"
                    >
                        <ArrowLeft className="mr-2 h-4 w-4" />
                        Go Back & Try Again
                    </Button>
                    <Button
                        variant="outline"
                        onClick={() => navigate('/company/dashboard')}
                        className="w-full rounded-full border-purple-200 hover:border-purple-400 hover:bg-purple-50"
                        data-testid="back-to-dashboard-btn"
                    >
                        Back to Dashboard
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PaymentCancelled;
